// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import TitleUnderlined from '../home/parts/banner/TitleUnderlined';
// Styles
import './styles.scss';


const propTypes = {
  titleContent: PropTypes.object.isRequired,
};
function Header(props) {
  const { title, content } = props.titleContent;
  return (
    <div className="lexique-header">
      <TitleUnderlined title={title}>
        <p className="lexique-header__subtitle">
          {content}
        </p>
      </TitleUnderlined>
    </div>
  );
}

Header.propTypes = propTypes;
export default Header;



// WEBPACK FOOTER //
// ./src/app/components/pages/lexique/Header.js